import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { mapDtoToGuideline } from 'shared/domain';
import { TreetopPropertiesProvider } from 'shared/util-common';

import { PaginationWrapperDto, GuidelineDto, Guideline } from '@treetop/shared/model';

import { Share } from '../model/cluster.model';

@Injectable({
  providedIn: 'root',
})
export class SharesHttpService {
  private http = inject(HttpClient);
  private readonly shareBaseUrl = `${TreetopPropertiesProvider.properties.baseUrl}api/shares`;

  public addShare(share: Share): Observable<Share> {
    return this.http.post<Share>(`${this.shareBaseUrl}`, share);
  }

  public getOutgoingShares(): Observable<PaginationWrapperDto<Share>> {
    return this.http.get<PaginationWrapperDto<Share>>(`${this.shareBaseUrl}/outgoing`);
  }

  public removeShare(shareId: string): Observable<void> {
    return this.http.delete<void>(`${this.shareBaseUrl}/${shareId}`);
  }

  public getIncomingShares(): Observable<PaginationWrapperDto<Share>> {
    return this.http.get<PaginationWrapperDto<Share>>(`${this.shareBaseUrl}/incoming`);
  }

  public acceptIncomingShare(share: Share): Observable<Share> {
    return this.http.put<Share>(`${this.shareBaseUrl}/accept`, share);
  }

  public denyIncomingShare(share: Share): Observable<Share> {
    return this.http.put<Share>(`${this.shareBaseUrl}/deny`, share);
  }

  public getGuidelinesForShare(shareId: string): Observable<Guideline[]> {
    return this.http.get<GuidelineDto[]>(`${this.shareBaseUrl}/${shareId}/guidelines`).pipe(map((dtos) => dtos.map(mapDtoToGuideline)));
  }

  public editShareSettings(share: Share): Observable<Share> {
    return this.http.put<Share>(`${this.shareBaseUrl}/settings`, share);
  }
}
